import React from 'react'
import { trackGuiInteracted } from 'src/dataLayer/remoteData/babbelEventStream'
import { useRouteParamsContext } from 'src/viewLayer/components/contexts/RouteParamsContext'
import { Link } from 'src/viewLayer/components/DesignSystem'

// eslint-disable-next-line func-names -- Legacy
export default function ({ href, trackingId, ...properties }) {
  const { learnLanguageCode, locale } = useRouteParamsContext()

  const trackClick = () => {
    if (!properties.disabled) {
      trackGuiInteracted({
        guiElementName: trackingId,
        learnLanguageCode,
        locale,
      })
    }
  }

  const handleClick = () => {
    trackClick()
    if (properties.onClick) {
      properties.onClick()
    }
  }

  return (
    <Link
      {...properties}
      // if there is no href passed it needs to be null to avoid
      // redirecting the user when we should only dismiss the webview
      href={href || null}
      onClick={handleClick}
    />
  )
}
